import { urlDateToDateTime } from 'common/UrlDate';
import { DateTime } from 'luxon';
import React from 'react';
import { ButtonSizes, PrimaryButton, SecondaryButton } from 'src/shared/design-system/Buttons';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'src/shared/design-system/Modal';
import { useSelector } from 'src/store';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';

const StyledModal = styled(Modal)`
  padding: ${Spacing.SINGLE_HALF};
  max-height: 80vh;
`;

const FooterFlex = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const AcknowledgeDeliveryDateChangeModal: React.FC<{
  isShowing: boolean;
  onClear: () => void;
  onAcknowledge: () => void;
}> = ({ isShowing, onClear, onAcknowledge }) => {
  const deliveryDate = useSelector((state) => state.cart.deliveryDate);
  const deliveryDateTime = urlDateToDateTime(deliveryDate, DateTime.utc().zoneName);

  return (
    <StyledModal isShowing={isShowing} showCloseButton onClose={onAcknowledge}>
      <ModalHeader>Delivery date updated</ModalHeader>
      <ModalBody>
        <p>
          The delivery date has been updated to the soonest available delivery date,{' '}
          <strong>
            {deliveryDateTime.weekdayLong}, {deliveryDateTime.monthLong} {deliveryDateTime.day}
          </strong>
          . All of your items in your cart may not be available.
        </p>
      </ModalBody>
      <ModalFooter>
        <FooterFlex>
          <SecondaryButton size={ButtonSizes.S} onClick={onClear}>
            Clear Cart
          </SecondaryButton>
          <PrimaryButton size={ButtonSizes.S} onClick={onAcknowledge}>
            Acknowledge
          </PrimaryButton>
        </FooterFlex>
      </ModalFooter>
    </StyledModal>
  );
};
